import { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Bell } from 'lucide-react';
import { isNotificationsSupported, requestNotificationPermission } from '@/lib/firebase';

export const NotificationPermission = () => {
  const [showPrompt, setShowPrompt] = useState(false);

  useEffect(() => {
    // Kiểm tra xem đã yêu cầu quyền thông báo chưa
    const hasAskedForPermission = localStorage.getItem('hasAskedForNotificationPermission');
    
    // Nếu chưa yêu cầu và trình duyệt hỗ trợ, hiện prompt
    if (!hasAskedForPermission && isNotificationsSupported()) {
      // Kiểm tra trạng thái quyền hiện tại
      if (Notification.permission !== 'granted' && Notification.permission !== 'denied') {
        setShowPrompt(true);
      }
    }
  }, []);

  if (!showPrompt) {
    return null;
  }

  // Xử lý khi người dùng yêu cầu quyền thông báo
  const handleRequestPermission = async () => {
    try {
      const token = await requestNotificationPermission();
      if (token) {
        console.log('Notification permission granted. Token:', token);
      }
      
      // Đánh dấu đã yêu cầu quyền
      localStorage.setItem('hasAskedForNotificationPermission', 'true');
      
      // Ẩn prompt
      setShowPrompt(false);
    } catch (err) {
      console.error('Error requesting notification permission:', err);
    }
  };

  // Xử lý khi người dùng từ chối
  const handleDismiss = () => {
    localStorage.setItem('hasAskedForNotificationPermission', 'true');
    setShowPrompt(false);
  };

  return (
    <Card className="mb-4 border-blue-200 bg-blue-50 dark:bg-blue-950/30 dark:border-blue-800">
      <CardContent className="p-4">
        <div className="flex items-center">
          <div className="bg-blue-100 p-2 rounded-full mr-3 dark:bg-blue-900">
            <Bell className="h-5 w-5 text-blue-600 dark:text-blue-400" />
          </div>
          <div className="flex-1">
            <h4 className="font-medium text-sm">Nhận thông báo</h4>
            <p className="text-sm text-muted-foreground">
              Cho phép thông báo để nhận cập nhật về đơn hàng và hoạt động quan trọng
            </p>
          </div>
          <div className="flex ml-4 gap-2">
            <Button variant="outline" size="sm" onClick={handleDismiss}>
              Bỏ qua
            </Button>
            <Button size="sm" onClick={handleRequestPermission}>
              Cho phép
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}; 